<template>
  <div>
    <div key="1" class="bg-green" style="padding: .5rem; margin-left:7px" v-if="examResults && CelotnoVprasanje.points == CelotnoVprasanje.maxPoints && CelotnoVprasanje.maxPoints != null">
      <span>
        {{$t('pages.exercise.answers.correct')}}
      </span>
    </div>
    <div key="2" class="bg-yellow" style="padding: .5rem; margin-left:7px" v-else-if="examResults && CelotnoVprasanje.points > 0">
      <span>
        {{$t('pages.exercise.answers.partiallyCorrect')}}
      </span>
    </div>
    <div key="3 n" class="bg-red" style="padding: .5rem; margin-left:7px" v-else-if="examResults && CelotnoVprasanje.points <= 0 && nameOfTheParent == 'numeric'">
      <span>
        {{$t('pages.exercise.answers.incorrect')}} {{$t('pages.exercise.answers.correctAnswer.singular')}} {{CelotnoVprasanje.answers[0].correct}}.
      </span>
    </div>
    <div key="3 r" class="bg-red" style="padding: .5rem; margin-left:7px" v-else-if="examResults && CelotnoVprasanje.points <= 0 && nameOfTheParent == 'radio'">
      <span>
        {{$t('pages.exercise.answers.incorrect')}} {{$t('pages.exercise.answers.correctAnswer.singular')}}: {{CelotnoVprasanje.answers.filter(x => x.correct).map(x => x.text.sl ? x.text.sl : x.text.en).join('')}}.
      </span>
    </div>
    <div key="3 m" class="bg-red" style="padding: .5rem; margin-left:7px" v-else-if="examResults && CelotnoVprasanje.points <= 0 && nameOfTheParent == 'multichoice'">
      <span>
        {{$t('pages.exercise.answers.incorrect')}} {{CelotnoVprasanje.answers.filter(x => x.correct).length == 1 ? $t('pages.exercise.answers.correctAnswer.singular') : CelotnoVprasanje.answers.filter(x => x.correct).length == 2 ? $t('pages.exercise.answers.correctAnswer.dual') : $t('pages.exercise.answers.correctAnswer.plural')}}: {{CelotnoVprasanje.answers.filter(x => x.correct).map(x => x.text.sl ? x.text.sl : x.text.en).join(', ')}}
      </span>
    </div>
    <div key="3 c" class="bg-red" style="padding: .5rem; margin-left:7px" v-else-if="examResults && CelotnoVprasanje.points <= 0 && nameOfTheParent == 'crypto'">
      <span>
        {{$t('pages.exercise.answers.incorrect')}} {{$t('pages.exercise.answers.correctAnswer.singular')}} {{'"' + CelotnoVprasanje.answers[0].text.sl.slice(16, -14) + '""'}}.
      </span>
    </div>
    <!--<div key="4" class="bg-gray" style="padding: .5rem; margin-left:7px" v-else-if="examResults && CelotnoVprasanje.points == null && CelotnoVprasanje.solution !== null">
      <span>
        {{$t('pages.exercise.answers.correctAnswer.singular')}} {{CelotnoVprasanje.solution.sl}}.
      </span>
    </div>-->
    <div key="5" class="bg-gray" style="padding: .5rem; margin-left:7px" v-else>
      <span>
        {{$t('pages.exercise.answers.noAnswer')}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['examResults', 'CelotnoVprasanje', 'nameOfTheParent']
}
</script>



// WEBPACK FOOTER //
// ShowSolutionExamResults.vue?456bb7da